// extracted by mini-css-extract-plugin
export default {"terms":"Btduq"};